import { CommonModule } from '@angular/common';
import { ComponentsModule } from 'src/app/components/components.module';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MembershipDiscountOfferPage } from './membership-discount-offer.page';
import { MembershipDiscountOfferPageRoutingModule } from './membership-discount-offer-routing.module';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MembershipDiscountOfferPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [MembershipDiscountOfferPage],
})
export class MembershipDiscountOfferPageModule {}
